import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Root,
  Content,
  Trigger,
  Separator,
} from '@radix-ui/react-dropdown-menu';

/**
 *  Visually distinct group of menu items
 */
export const MenuSection = styled.ul`
  padding: 5px;
`;

/**
 * Separates MenuSections
 */
export const MenuSeparator = styled(Separator)`
  border-bottom: 0;
  border-top: 1px solid var(--ui-vertical-separator);
`;

export const MenuContentWrapper = styled.ul`
  --menu-bg: var(--white);

  background-color: var(--menu-bg);
  border-radius: 6px;
  box-shadow: var(--level-1);
  width: 240px;
`;

/**
 * Container of menu items/ListRows, visible when menu
 * is open
 */
export const MenuContent = ({ children, ...props }) => (
  <Content asChild {...props}>
    <MenuContentWrapper>{children}</MenuContentWrapper>
  </Content>
);

MenuContent.propTypes = {
  children: PropTypes.node,
  // Inherits props from @radix-ui/react-dropdown-menu
  // see radix docs: https://www.radix-ui.com/docs/primitives/components/dropdown-menu#content
};

/** contains the button which opens/closes the menu */
export const MenuTrigger = styled(Trigger)`
  &:focus-visible {
    outline-width: 0px;
  }
`;

/** Wrapper of the entire menu component, including trigger */
export const Menu = styled(Root)``;
